var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X",
    clipPath: "url(#clip0_8673_1586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.72828 12.1868L4.48619 4.55939H9.02672L12.9218 8.47693L16.2893 4.55939H18.1751L22.2667 8.73511V4.57062C22.2667 2.42102 20.5043 0.658691 18.3547 0.658691H4.57037C2.42078 0.658691 0.658447 2.42102 0.658447 4.57062V18.3606C0.658447 20.5102 2.42078 22.2725 4.57037 22.2725H8.38128L4.40761 18.3718L9.72828 12.1868Z",
    fill: "url(#paint0_linear_8673_1586)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.2724 18.3605V8.72943L18.1808 4.55371H16.295L12.9275 8.47125L9.03243 4.55371H4.48629L9.72838 12.1867L4.40771 18.3717L8.38138 22.2724H18.3604C20.51 22.2724 22.2724 20.5101 22.2724 18.3605Z",
    fill: "#161616"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.523 18.372H13.9824L10.57 13.4049L6.29889 18.372H4.41309L9.73376 12.187L4.48605 4.55957H9.02658L12.2538 9.25164L16.2948 4.55957H18.1806L13.0957 10.4696L18.5286 18.372H18.523ZM14.2743 17.8107H17.4566L12.3829 10.4303L16.9515 5.11521H16.5474L12.2033 10.1665L8.72912 5.11521H5.54682L10.4297 12.2207L5.62539 17.8051H6.02949L10.6093 12.4788L14.2687 17.8051L14.2743 17.8107ZM16.9627 17.5526H14.5212L6.0351 5.41829H8.47655L16.9571 17.5526H16.9627ZM14.8131 16.9913H15.8851L8.1847 5.97954H7.11271L14.8075 16.9913H14.8131Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8673_1586",
    x1: 1.02887,
    y1: 2.70726,
    x2: 21.8962,
    y2: 20.2183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8673_1586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6138,
    height: 21.6138,
    fill: "white",
    transform: "translate(0.658447 0.658691)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.e5d29d1581d5a9d33fdda0b44c5c6b6d.svg";
export { ForwardRef as ReactComponent };